import React from 'react';
import { View, Text, ScrollView, StyleSheet } from 'react-native';

const Help = () => {
  return (
    <ScrollView style={styles.container} contentContainerStyle={styles.content}>
      <View style={styles.header}>
        <Text style={styles.title}>Help & Support</Text>
        <Text style={styles.subtitle}>Get the most out of your Zecher experience</Text>
      </View>

      <View style={styles.section}>
        <Text style={styles.sectionTitle}>Getting Started</Text>
        <View style={styles.card}>
          <Text style={styles.cardTitle}>📱 Connect Your Accounts</Text>
          <Text style={styles.cardText}>
            Securely link your bank accounts, credit cards, and investment accounts using Plaid.
          </Text>
        </View>
        
        <View style={styles.card}>
          <Text style={styles.cardTitle}>📊 View Your Dashboard</Text>
          <Text style={styles.cardText}>
            Get a complete overview of your financial health with insights and analytics.
          </Text>
        </View>
        
        <View style={styles.card}>
          <Text style={styles.cardTitle}>💰 Track Spending</Text>
          <Text style={styles.cardText}>
            Monitor your expenses and see where your money goes with detailed categories.
          </Text>
        </View>
      </View>

      <View style={styles.section}>
        <Text style={styles.sectionTitle}>Frequently Asked Questions</Text>
        
        <View style={styles.faqItem}>
          <Text style={styles.faqQuestion}>Is my financial data secure?</Text>
          <Text style={styles.faqAnswer}>
            Yes! We use bank-level security with 256-bit encryption and never store your banking credentials.
          </Text>
        </View>
        
        <View style={styles.faqItem}>
          <Text style={styles.faqQuestion}>How do I add a new account?</Text>
          <Text style={styles.faqAnswer}>
            Go to the Accounts page and click "Add Account" to securely connect a new financial institution.
          </Text>
        </View>
        
        <View style={styles.faqItem}>
          <Text style={styles.faqQuestion}>Can I categorize my transactions?</Text>
          <Text style={styles.faqAnswer}>
            Yes! Transactions are automatically categorized, and you can customize categories as needed.
          </Text>
        </View>
      </View>

      <View style={styles.section}>
        <Text style={styles.sectionTitle}>Contact Support</Text>
        <View style={styles.contactCard}>
          <Text style={styles.contactTitle}>Need additional help?</Text>
          <Text style={styles.contactText}>
            Our support team is here to help you with any questions or issues.
          </Text>
          <Text style={styles.contactInfo}>📧 support@zecher.ai</Text>
          <Text style={styles.contactInfo}>📞 (516) 660-2268</Text>
        </View>
      </View>
    </ScrollView>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#F9FAFB',
  },
  content: {
    maxWidth: 800,
    width: '100%',
    alignSelf: 'center',
    paddingHorizontal: 24,
    paddingVertical: 32,
  },
  header: {
    marginBottom: 32,
    alignItems: 'center',
  },
  title: {
    fontSize: 32,
    fontWeight: 'bold',
    color: '#111827',
    marginBottom: 8,
    textAlign: 'center',
  },
  subtitle: {
    fontSize: 18,
    color: '#6B7280',
    textAlign: 'center',
  },
  section: {
    marginBottom: 32,
  },
  sectionTitle: {
    fontSize: 24,
    fontWeight: '600',
    color: '#111827',
    marginBottom: 16,
  },
  card: {
    backgroundColor: '#FFFFFF',
    borderRadius: 12,
    padding: 20,
    marginBottom: 16,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 1 },
    shadowOpacity: 0.05,
    shadowRadius: 3,
    elevation: 1,
  },
  cardTitle: {
    fontSize: 18,
    fontWeight: '600',
    color: '#111827',
    marginBottom: 8,
  },
  cardText: {
    fontSize: 16,
    color: '#6B7280',
    lineHeight: 24,
  },
  faqItem: {
    backgroundColor: '#FFFFFF',
    borderRadius: 12,
    padding: 20,
    marginBottom: 12,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 1 },
    shadowOpacity: 0.05,
    shadowRadius: 3,
    elevation: 1,
  },
  faqQuestion: {
    fontSize: 18,
    fontWeight: '600',
    color: '#111827',
    marginBottom: 8,
  },
  faqAnswer: {
    fontSize: 16,
    color: '#6B7280',
    lineHeight: 24,
  },
  contactCard: {
    backgroundColor: '#EFF6FF',
    borderRadius: 12,
    padding: 24,
    alignItems: 'center',
  },
  contactTitle: {
    fontSize: 20,
    fontWeight: '600',
    color: '#1E40AF',
    marginBottom: 8,
    textAlign: 'center',
  },
  contactText: {
    fontSize: 16,
    color: '#374151',
    marginBottom: 16,
    textAlign: 'center',
  },
  contactInfo: {
    fontSize: 16,
    fontWeight: '500',
    color: '#1E40AF',
    marginBottom: 4,
  },
});

export default Help; 